import ApplicationController from '../editor/application_controller';

export default class extends ApplicationController {
  static targets = ["content"]

  async showStudentPosts(event) {
    event.preventDefault();
    const link = event.currentTarget;
    const url = link.href;

    try {
      const response = await fetch(url, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      const html = await response.text();

      // Replace the main content area with the student posts
      const contentArea = document.querySelector('.x1-main-content');
      if (contentArea) {
        contentArea.innerHTML = html;
      }
    } catch (error) {
      console.error('Error loading student posts:', error);
    }
  }
}
